/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Action_ArchiveInputs */

const en_clients_action_archive = /** @type {(inputs: Clients_Action_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const pt_br2_clients_action_archive = /** @type {(inputs: Clients_Action_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivar`)
};

/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Clients_Action_ArchiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_action_archive = /** @type {((inputs?: Clients_Action_ArchiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Action_ArchiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_action_archive(inputs)
	return pt_br2_clients_action_archive(inputs)
});